import React from 'react';
import { Button } from 'react-bootstrap';
import withHelpText from './withHelpText';

const ButtonHelpText = withHelpText(function ButtonHelpText({ ...props }) {
  return <Button {...props}>{props.children}</Button>;
});

export default ButtonHelpText;
